import React, { useEffect, useMemo, useState } from 'react';
import useLayoutContext from '@hooks/useLayoutContext';

const CaptivePortalContinue = () => {
  const { guestDuration, casLoginUrl, isSso } = useLayoutContext();
  const [isSsoRedirect, setIsSsoRedirect] = useState(false);
  const duration = useMemo(() => {
    if (!guestDuration) {
      return '';
    }
    const days = Math.floor(guestDuration / 86400);
    const remainingHours = Math.floor((guestDuration % 86400) / 3600);

    if (days > 0 && remainingHours > 0) {
      return `${days} day${days > 1 ? 's' : ''} ${remainingHours} hour${
        remainingHours > 1 ? 's' : ''
      }`;
    } else if (days > 0) {
      return `${days} day${days > 1 ? 's' : ''}`;
    } else {
      return `${remainingHours} hour${remainingHours > 1 ? 's' : ''}`;
    }
  }, [guestDuration]);

  useEffect(() => {
    if (isSso) {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const redirectToSso = urlParams.get('sso') === 'true';
      setIsSsoRedirect(redirectToSso);
      if (redirectToSso) {
        const url = `${window.location.origin}/captive-portal/instructions`;
        if (casLoginUrl && typeof casLoginUrl === 'function') {
          window.location.href = casLoginUrl(url || '');
        }
      }
    }
  }, [casLoginUrl, isSso]);

  return isSsoRedirect ? null : (
    <div>
      <div className="mb-2 text-center">
        <h2 style={{ fontSize: '125%' }} className="pb-5">
          Thank You!
        </h2>
      </div>
      <div className="mb-5">
        <p>Your Guest Account has been created and this device is now online!</p>
      </div>
      <div className="mb-5">
        <p>Guest access will expire in {duration}.</p>
      </div>
    </div>
  );
};

export default CaptivePortalContinue;
